import { useConfigStore } from '~/store/useConfigStore'

export const useGoogleAnalyticsIntegration = () => {
  const { info } = useLogger('integrations/useGoogleAnalyticsIntegration')
  const configStore = useConfigStore()

  const { googleAnalyticsId } = storeToRefs(configStore)

  if (!googleAnalyticsId.value) {
    info('Google Analytics ID is not configured.')

    return {
      googleAnalytics: null,
    }
  }

  const { proxy: googleAnalytics } = useScriptGoogleAnalytics({
    id: googleAnalyticsId.value,
  })

  return { googleAnalytics }
}
